import {Section, SectionType} from '../../../api/models';
import {LatestUpdateCompanionComponent} from './latestupdate/LatestUpdateCompanionComponent';

import {TestimonialsCompanionComponent} from './testimonials/TestimonialsCompanionComponent';
import {UpdateContactInfoComponent} from './contactinfo/UpdateContactInfoComponent';
import {MediaCompanionComponent} from './media/MediaCompanionComponent';
import {CatalogCompanionComponent} from './catalog/CatalogCompanionComponent';

interface Props {
    section: Section;
    websiteId: string;
    throwSnackbarMessage: (message: string) => void;
    refetch: VoidFunction;
}

export const CompanionComponentResolver = (props: Props) => {
    switch (props.section?.sectionType) {
        case SectionType.TESTIMONIALS:
            return <TestimonialsCompanionComponent {...props} />;
        case SectionType.MEDIA:
            return <MediaCompanionComponent {...props} />;
        case SectionType.LATEST_UPDATE:
            return <LatestUpdateCompanionComponent {...props} />;
        case SectionType.HERO:
        case SectionType.CONTACT:
            return <UpdateContactInfoComponent {...props} />;
        case SectionType.CATALOG:
            return <CatalogCompanionComponent {...props} />;
        default:
            return <></>;
    }
};
